// After a deploy rotates chunk hashes, a still-open tab's dynamic `import()`
// — a route lazy-load, a code-split component, or a locale catalog chunk —
// tries to fetch a file the server no longer has and rejects with the
// browser's standard chunk-fetch TypeError. A single full reload pulls the
// fresh index.html and its current chunk hashes.
//
// Single-fire: if the new bundle ALSO fails (a genuine network outage, or a
// deploy that produced a self-inconsistent bundle) the user sees one reload
// then the error UI — the correct fallback, better than an infinite reload
// loop.
let reloadFired = false;

export function reloadOnceForStaleBundle(): void {
  if (reloadFired) return;
  reloadFired = true;
  window.location.reload();
}

// The TypeError text Chromium/Firefox/Safari all emit when a dynamic import's
// chunk fetch 404s. Matching on it distinguishes a stale-bundle failure (retry
// by reloading) from an application error (surface / log it).
const CHUNK_FETCH_FAILURE = 'Failed to fetch dynamically imported module';

export function isStaleBundleError(reason: unknown): boolean {
  const message =
    reason !== null && typeof reason === 'object' && 'message' in reason
      ? String((reason as { message: unknown }).message)
      : String(reason);
  return message.includes(CHUNK_FETCH_FAILURE);
}
